import React from "react"

import { Tilt3D, Tilt3DLayer } from "../../../../../clux-ui/components"

import "./style.scss"

interface PresentationProps {
  title: string
  background: string
  envelope: string
  logo: string
  onOpen: () => void
}

/** Profondeur du logo au-dessus de l'enveloppe */
const LOGO_DEPTH = "2.5rem"
/** Arrondi du reflet, identique à celui de l'image de l'enveloppe ($dc-radius-s) */
const ENVELOPE_RADIUS = "0.5rem"

/** Étape de présentation : une enveloppe animée en 3D à ouvrir pour commencer l'enquête */
const Presentation = ({
  title,
  background,
  envelope,
  logo,
  onOpen,
}: PresentationProps) => (
  <div
    className="dc-presentation"
    style={{ backgroundImage: `url(${background})` }}
  >
    <h1 className="dc-visually-hidden">{title}</h1>
    {/* L'enveloppe suit la souris dans toute la fenêtre */}
    <Tilt3D tracking="window" shine float borderRadius={ENVELOPE_RADIUS}>
      <button
        type="button"
        className="dc-presentation__envelope"
        aria-label="Ouvrir l'enveloppe et commencer l'enquête"
        onClick={onOpen}
      >
        <img
          className="dc-presentation__envelope-image"
          src={envelope}
          alt=""
        />
        <Tilt3DLayer depth={LOGO_DEPTH} className="dc-presentation__logo">
          <img src={logo} alt="" />
        </Tilt3DLayer>
      </button>
    </Tilt3D>
  </div>
)

export default Presentation
